import { render, staticRenderFns } from "./ClientInvoice.vue?vue&type=template&id=3e3a171b&"
import script from "./ClientInvoice.vue?vue&type=script&lang=js&"
export * from "./ClientInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports